import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { connect } from "react-redux";

import TransfersToDeduct from "./TransfersToDeduct";
import TransfersFilters from "./../TransfersFilters";
import { columns } from "./TransfersEmployee.utils";
import Modal from "../../../../components/modalComponent/ModalComponent";

import Spinner from "./../../../stats/components/Spinner";
import { transferUserDeductionCurrentProvider, transferUserDeductionProvider } from "../../../../lib/api/providers";

const initializeDataToDeduct = {
  advanced: {
    amount: 0,
    total: true
  },
  fines: null,
  personalDistance: null
};

const TransfersEmployee = ({ fetchTransfers, isTransfersLoading, token, userRoleId, transfersByUsers = [] }) => {
  const modalTitle = "A déduire";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const [selectedUserName, setSelectedUserName] = useState();
  const [dataToDeduct, setDataToDeduct] = useState(initializeDataToDeduct);
  const [userIdSelected, setUserIdSelected] = useState(null);

  const updateUserDeduction = async (params = {}) => {
    await transferUserDeductionProvider
      .post(
        "/",
        { ...params, user_id: userIdSelected },
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          fetchTransfers();
          setIsModalOpen(false);
        }
      });
  };

  const getUserDeduction = async (params = {}) => {
    await transferUserDeductionCurrentProvider
      .get(`/${params.user_id}`, {
        headers: {
          Authorization: token
        }
      })
      .then(response => {
        if (response.data)
          setDataToDeduct({
            ...dataToDeduct,
            advanced: {
              amount: response.data.amount,
              total: response.data.total
            }
          });
        else setDataToDeduct(initializeDataToDeduct);
        setUserIdSelected(params.user_id);
      });
  };

  const onClickToDeduct = userId => {
    getUserDeduction({ user_id: userId });
    setIsModalOpen(true);
  };

  const getTableData =
    transfersByUsers &&
    transfersByUsers.filter(
      transfersByUser =>
        (!selectedUserName || selectedUserName === transfersByUser.user_fullname) &&
        (!selectedCompanyId || selectedCompanyId === transfersByUser.user_company_id) &&
        transfersByUser.status &&
        (!selectedStatus || selectedStatus === transfersByUser.status.label)
    );

  if (isTransfersLoading) return <Spinner />;
  return (
    <div>
      <TransfersFilters
        setSelectedUserName={setSelectedUserName}
        setSelectedStatus={setSelectedStatus}
        setSelectedCompanyId={setSelectedCompanyId}
        token={token}
        userRoleId={userRoleId}
        data={getTableData}
        menuItem="employee"
      />
      <div className="mr-12 mb-12">
        <Table
          columns={columns(onClickToDeduct)}
          rowKey={(_, index) => index}
          dataSource={getTableData}
          bordered
          size="middle"
          pagination={false}
        />
      </div>
      <Modal width="651px" title={modalTitle} showModal={isModalOpen} closeModal={() => setIsModalOpen(false)}>
        <TransfersToDeduct
          updateUserDeduction={updateUserDeduction}
          dataToDeduct={dataToDeduct}
          setDataToDeduct={setDataToDeduct}
          onClose={() => {
            setIsModalOpen(false);
          }}
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    userRoleId: state.userInfos.role_id,
    transfersByUsers: state.transfers.listByUsers,
    isTransfersLoading: state.transfers.isLoading
  };
};

export default connect(mapStateToProps)(TransfersEmployee);



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersEmployee/TransfersEmployee.js